import { createStyles } from 'antd-style';

const useWorkspaceAuthModalStyles = createStyles(({ token, css }) => ({
  modalBody: css`
    padding: 32px 0 16px;
    text-align: center;
  `,
  icon: css`
    width: 80px;
    margin-bottom: 24px;
  `,
  title: css`
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
    color: #222;
  `,
  desc: css`
    color: #888;
    font-size: 14px;
    margin-bottom: 12px;
    line-height: 1.6;
  `,
  deadline: css`
    color: #888;
    font-size: 13px;
    margin-top: 8px;
  `,
  primaryBtn: css`
    width: 200px;
    margin: 16px 0;
    border-radius: 30px;
    font-size: 15px;
    font-weight: 500;
    height: 38px;
  `,
  stepModalBody: css`
    padding: 24px;
  `,
  stepTitle: css`
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 8px;
    color: #222;
  `,
  stepDesc: css`
    color: #888;
    font-size: 13px;
    margin-bottom: 16px;
    line-height: 1.6;
  `,
  memberList: css`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    justify-content: flex-start;
  `,
  memberCard: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 60px;
    max-width: 80px;
  `,
  memberAvatar: css`
    margin-bottom: 4px;
  `,
  memberName: css`
    font-size: 13px;
    color: #222;
  `,
  leader: css`
    color: #52c41a;
    margin-left: 4px;
    font-size: 12px;
  `,
  memberFormCard: css`
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    text-align: left;
  `,
  memberFormHeader: css`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  `,
  divider: css`
    margin: 16px 0;
    border-top: 1px solid #eee;
  `,
  stepFooter: css`
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  `,
  confirmCard: css`
    min-width: 320px;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    text-align: left;
  `,
  confirmHeader: css`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  `,
  confirmName: css`
    font-weight: 500;
    color: #222;
    margin-left: 10px;
  `,
  confirmLeader: css`
    color: #52c41a;
    margin-left: 8px;
    font-size: 12px;
  `,
}));

export default useWorkspaceAuthModalStyles; 